import {currentUsersKeys} from "./currentUsers";
import {playKeys} from "./play";
import {socialKeys} from "./social";
import {studioKeys} from "./studio";
import {userKeys} from "./user";
import {assetKeys} from "./assetLibrary";

export const queryKeys = {
  ...currentUsersKeys,
  ...playKeys,
  ...socialKeys,
  ...studioKeys,
  ...userKeys,
  ...assetKeys,
};

export const queryStatus = {
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
};
